module.exports = __webpack_public_path__ + "static/media/4.a610a95b.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/eyes/4.png
// module id = 544
// module chunks = 0